import { v4 as uuid } from 'uuid';

import { SBaseDisplay } from '@summit/core';

import { EboNameObject } from '../base-classes/ebo-name-object';
import { Route } from './route';
import { ScheduleTemplateLeg } from './schedule-template-leg';

export class RouteAltWeek extends EboNameObject implements SBaseDisplay {
  routeID: string;
  route: Route;
  fedExWeek: number;
  order: number;
  comment: string;
  templates: ScheduleTemplateLeg[];

  constructor(jsonData?: Partial<RouteAltWeek>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.route) {
        this.route = new Route(jsonData.route);
      }
      if (jsonData.templates) {
        this.templates = jsonData.templates
          .map((data) => new ScheduleTemplateLeg(data))
          .sort((a, b) => (a.defaultSort > b.defaultSort ? 1 : -1));
      }
    }
    this.templates ??= [];
    this.id ??= uuid();
  }

  toShortString(_param?: string): string {
    return this.name;
  }
}
